import React from 'react';
import './Home.css';
import Sections from '../../components/Sections'


const Home = () => {
	
	return (
		<div className='homeBody'>
      <div className='homeContainer'>
				<div>
					<Sections />
				</div>
				
      </div>
		</div>
	);
};

export default Home;